import { ThemeProvider } from "@emotion/react"
import { Box, LinkButton, Text, theme } from "@pallet-hq/hegel"
import config from "config"
import { FiCalendar } from "react-icons/fi"

const BookCallBanner = () => {
    return (
        <ThemeProvider theme={theme}>
            <Box
                display="flex"
                flexDirection={["column", "row", "row"]}
                alignItems="center"
                justifyContent="space-between"
                gridGap="xsmall"
                mx="auto"
                maxWidth="700px"
            >
                <Box display="flex" flexDirection="column">
                    <Text
                        variant="headlineLarge"
                        textAlign={["center", "initial", "initial"]}
                    >
                        Got any questions?
                    </Text>
                    <Text
                        variant="paragraphMedium"
                        textAlign={["center", "initial", "initial"]}
                        color="gray600"
                    >
                        Feel free to book a call with our team,
                        <br />
                        we&apos;re ready to help.
                    </Text>
                </Box>
                <LinkButton variant="primary" href={config.CALENDLY_FAQ_URL}>
                    <Box display="flex" alignItems="center" gridGap="xsmall">
                        <FiCalendar />
                        Book a call with us
                    </Box>
                </LinkButton>
            </Box>
        </ThemeProvider>
    )
}

export default BookCallBanner
